<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import snContentService from '../../../services/snContentService'

export default {
  name: 'App',
  data () {
    return {
      store: this.$store
    }
  },
  computed: {
    sac () {
      let givenCode = ''
      const pathArray = location.pathname.split('/')
      pathArray.shift()
      if (pathArray[2] || pathArray[3]) { // e.g. .../signup/asmith1@banknorth.com
        givenCode = pathArray[pathArray.length - 1]
      }
      return givenCode
    }

  },
  created () {
    this.setUpBorrowerWebContent()
  },
  methods: {
    async setUpBorrowerWebContent () {
      const { data: { content } } = await snContentService.borrowerWebContent(this.sac)
      if (content) {
        this.store.borrowerWebContent = JSON.parse(content)
      }
    }
  }
}
</script>
